import { css } from "@emotion/react";
import styled from "@emotion/styled";

const colors = {
  primary: "#111847",
  secondary: "#A37C0C",
  third: "#9B9B9B",
  backgroundColor: "white",
  primary400: "#3F3E73",
  primary300: "#6C68A1",
  primary200: "#9B95D2",
  primary100: "#CCC5FF",
  third100: "#DADADA",
  third200: "#7E7E7E",
  primary500: "#e3f2fd",
};

export default colors;

export const StyledForm = styled("form")(({ theme }) => ({
  backgroundColor: theme.palette.mode === "dark" ? "#1A2027" : "#fff",
  width: "100%",
  padding: "40px 25px",
  display: "flex",
  flexDirection: "row",
  flexWrap: "wrap",
  gap: "30px",
  border: `0.5px solid ${theme.palette.secondary}`,
}));
